import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PagamentoDespesaPagarComponent } from "./pagamento-despesa-pagar.component";
import { PagamentoDespesaPagarRoutingModule } from "./pagamento-despesa-pagar-routing.module";

import { ButtonModule } from "primeng/button";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from 'primeng/table';
import { TooltipModule } from "primeng/tooltip";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { InputMaskModule } from 'primeng/inputmask';
import { MessagesModule } from 'primeng/messages';
import {InputSwitchModule} from 'primeng/inputswitch';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from "primeng/inputnumber";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ConfirmationService } from "primeng/api";
import { ProgressSpinnerModule } from "primeng/progressspinner";





@NgModule({
    imports: [
        CommonModule,            
        PagamentoDespesaPagarRoutingModule,
        FormsModule,
        TableModule,      
        ButtonModule,
        InputTextModule,
        TooltipModule,
        DropdownModule,
        InputMaskModule,
        MessagesModule,
        InputSwitchModule,
        CalendarModule,
        InputNumberModule,
        ConfirmDialogModule,
        ProgressSpinnerModule

    ],
    declarations: [PagamentoDespesaPagarComponent],
    providers: [ConfirmationService]
})
export class PagamentoDespesaPagarModule { }
